import { styled, css } from 'styled-components';

import { useAppSelector } from '../../../shared/hooks/use-app-selector';

import LogoShore from '../../../assets/images/logos/logo_shore.svg';
import LogoShoreMark from '../../../assets/images/logos/logo_shore_figurative_mark.svg';
import LogoLocalsearch from '../../../assets/images/logos/logo_localsearch.svg';
import LogoLocalsearchMark from '../../../assets/images/logos/logo_localsearch_figurative_mark.svg';

const logoIconStyles = css`
  width: 123px;
  height: 24px;
  flex-shrink: 0;
  pointer-events: none;
  transition:
    width 200ms ease-in-out,
    height 200ms ease-in-out;
`;

const logoMarkStyles = css`
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  pointer-events: none;
`;

const StyledLogoShoreIcon = styled(LogoShore)`
  ${logoIconStyles}
`;

const StyledLogoShoreMark = styled(LogoShoreMark)`
  ${logoMarkStyles}
`;

const StyledLogoLocalsearchIcon = styled(LogoLocalsearch)`
  ${logoIconStyles}
`;

const StyledLogoLocalsearchMark = styled(LogoLocalsearchMark)`
  ${logoMarkStyles}
`;

export const companyLogoMapping = {
  shore: {
    full: StyledLogoShoreIcon,
    mark: StyledLogoShoreMark,
  },
  localsearch: {
    full: StyledLogoLocalsearchIcon,
    mark: StyledLogoLocalsearchMark,
  },
};

export type CompanyName = keyof typeof companyLogoMapping;

/**
 * The white-labelled logo pair for the current merchant. Shared by the side
 * menu and the mobile header so both brand the same way — the header shows the
 * `mark` because a 123px wordmark does not fit a phone's app bar next to a
 * menu button, a search button and an avatar.
 */
export function useBrandLogos(isLoading?: boolean) {
  const currentMerchant = useAppSelector((state) => state.currentMerchant);

  const whiteLabel = (
    !isLoading && currentMerchant.whiteLabel
      ? currentMerchant.whiteLabel
      : 'shore'
  ) as CompanyName;

  const { full, mark } =
    companyLogoMapping?.[whiteLabel] || companyLogoMapping.shore;

  return { whiteLabel, FullLogo: full, LogoMark: mark };
}
